import axios from "axios";

const openRouterAxios = axios.create({
  baseURL: "https://openrouter.ai/api/v1",
  headers: {
    "Authorization": `Bearer ${process.env.REACT_APP_OPENROUTER_API_KEY}`,
    "Content-Type": "application/json",
    "HTTP-Referer": "https://web.workbrook.com",
    "X-Title": "Workbrook",
  },
});

export const openRouter = {
  chat: async (messages) => {
    try {
      const response = await openRouterAxios.post("/chat/completions", {
        model: "mistralai/mistral-7b-instruct",
        messages,
      });

      return response.data.choices[0].message.content;
    } catch (error) {
      console.error("OpenRouter API Error:", error.response?.data || error.message);
      throw new Error(`OpenRouter API failed: ${error.response?.data?.error?.message || error.message}`);
    }
  },
};

// Usage example:
// openRouter.chat([
//   {
//     role: "user",
//     content: "Hello, how are you?",
//   },
// ]);